"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getDataDictionaryViews = void 0;
const getDataDictionaryView_1 = require("./getDataDictionaryView.js");
const sonar_http_1 = require("@sonar-software/sonar-http");
const getDataDictionaryViewsForSonarObject = (0, sonar_http_1.createGetEndpoint)((request) => `/api/v3/data-dictionary/views/fields/${request.sonarObjectId}`);
const getDataDictionaryViewsForType = (0, sonar_http_1.createGetEndpoint)((request) => `/api/v3/data-dictionary/views/sonar-objects/types/${request.sonarObjectType}`);
const getDataDictionaryViewsForApp = (0, sonar_http_1.createGetEndpoint)((request) => `/api/v3/data-dictionary/views/applications/${request.applicationId}`);
const getDataDictionaryViewsForTag = (0, sonar_http_1.createGetEndpoint)((request) => `/api/v3/data-dictionary/views/tags/${request.tagId}`);
const getDataDictionaryViewsForComplianceCategory = (0, sonar_http_1.createGetEndpoint)((request) => `/api/v3/data-dictionary/views/compliance-categories/${request.complianceCategory}`);
const getDataDictionaryViews = (request) => __awaiter(void 0, void 0, void 0, function* () {
    let response;
    if (request.sonarObjectId) {
        response = yield getDataDictionaryViewsForSonarObject(request);
    }
    else if (request.sonarObjectType) {
        response = yield getDataDictionaryViewsForType(request);
    }
    else if (request.applicationId) {
        response = yield getDataDictionaryViewsForApp(request);
    }
    else if (request.tagId) {
        response = yield getDataDictionaryViewsForTag(request);
    }
    else {
        response = yield getDataDictionaryViewsForComplianceCategory(request);
    }
    if (!response.data) {
        return Object.assign(Object.assign({}, response), { data: undefined });
    }
    const views = response.data;
    yield Promise.all(views.map((view, viewIndex) => (0, getDataDictionaryView_1.getDataDictionaryView)({ id: view.id }).then((viewDetailsResponse) => {
        const viewDetails = viewDetailsResponse.data;
        if (!viewDetails) {
            return;
        }
        views[viewIndex] = Object.assign(Object.assign({}, view), { columns: viewDetails.columns, filter: viewDetails.filter, ordering: viewDetails.ordering, sharedKey: viewDetails.sharedKey });
    })));
    return Object.assign(Object.assign({}, response), { data: { results: response.data } });
});
exports.getDataDictionaryViews = getDataDictionaryViews;
//# sourceMappingURL=getDataDictionaryViews.js.map